import React, { createContext, useContext, useState } from 'react'

export interface BasketData {
  priceLookupKeys: string[]
}

interface BasketContextProps {
  basketData: BasketData
  setBasketData: React.Dispatch<React.SetStateAction<BasketData>>
}

export const BasketContext = createContext<BasketContextProps | undefined>(undefined)

interface BasketProviderProps {
  children: React.ReactNode
}

export const BasketProvider: React.FC<BasketProviderProps> = ({ children }) => {
  const [basketData, setBasketData] = useState<BasketData>({
    priceLookupKeys: [],
  })

  return <BasketContext.Provider value={{ basketData, setBasketData }}>{children}</BasketContext.Provider>
}

export const useBasket = () => {
  const context = useContext(BasketContext)
  if (context === undefined) {
    throw new Error('useBasket must be used within a BasketProvider')
  }
  return context
}
